import styled, { css } from 'styled-components'
import { ReactComponent as PencilIcon } from 'presentation/assets/icons/pencil.svg'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Inputs = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`

export const CidContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-top: 32px;
  gap: 40px 5%;
`

export const QuantityContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 20px;

  input {
    width: 58px;
    padding: 0;
    margin: 0;
    text-align: center;
  }

  h5 {
    margin-right: 10px;
  }
`

export const Title = styled.h5`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.large};
    font-weight: 400;
    color: ${theme.colors.gray};
    cursor: pointer;
  `}
`

export const Pencil = styled(PencilIcon)`
  rect {
    fill-opacity: 1;
    fill: #e2ede3;
  }
`

export const InputButtonContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-end;
  align-items: flex-end;
  align-self: flex-start;
  width: 100%;
`
